/* A list of types and interfaces for caseflow facts, stations, etc.
 *
 * Not currently used for the most part, but listing them here both provides documentation for the
 * actual shape of the data used in facts and allows them to be used right away once support for them is added.
 *
 * The CFCF prefix stands for CaseFlow Case Fact.
 * So things don't end up all over the place when it comes to casing and naming conventions again, I'm now deciding that all CFCF types
 * will have their object keys using snake_case, while the interfaces themselves are in CamelCase save for the prefix.
 *
 * A WIP. Some of these might end up being common to all caseflow configurations, and should be moved to a shared location.
 */

import { Money, UserUploadedDocument } from '@rabbit/data/types';

/* -------------------------------------------------------------------------- */
/*                                  Stations                                  */
/* -------------------------------------------------------------------------- */

export enum CaseFlowStations_Fatbikes {
  BIRTH = '_birth',
  PRELIMINARY_ASSESSMENT = 'preliminary_assessment',
  PROFORMA_INVOICE = 'proforma_invoice',
  PROFORMA_INVOICE_SUBMISSION = 'proforma_invoice_submission',
  PROFORMA_INVOICE_ASSESSMENT = 'proforma_invoice_assessment',
  PROFORMA_INVOICE_ACCEPTED = 'proforma_invoice_accepted',
  REPAIR_INVOICE = 'repair_invoice',
  REPAIR_INVOICE_SUBMISSION = 'repair_invoice_submission',
  REPAIR_INVOICE_ASSESSMENT = 'repair_invoice_assessment',
  INVOICE_ACCEPTED = 'invoice_accepted',
  IN_REPAIR = 'in_repair',
  REPAIRED = 'repaired',
  CLOSED = 'closed',
  ARCHIVED = 'archived',
}
/* -------------------------------------------------------------------------- */
/*                                    Facts                                   */
/* -------------------------------------------------------------------------- */

export enum ExternalRepairInvoiceStatus {
  UNSUBMITTED = 'Unsubmitted',
  IN_REVIEW = 'In review',
  REJECTED = 'Rejected',
  APPROVED = 'Approved',
}

export enum ExternalRepairInvoiceType {
  PROFORMA = 'proforma',
  REPAIR = 'repair',
}

export interface CFCF_ExternalRepairInvoice {
  file: UserUploadedDocument;
  totalCost: Money;
  status: ExternalRepairInvoiceStatus;
  rejectionReason?: string;
  timestamp: number;
  invoiceType: ExternalRepairInvoiceType;
}

/* -------------------------------------------------------------------------- */
/*                                   Actions                                  */
/* -------------------------------------------------------------------------- */
export enum CaseFlowActions_Fatbikes_ExternalRepairer {
  /* ---------------------------- Station specific ---------------------------- */
  RepairCovered = 'repair_covered',
  RepairNotCovered = 'repair_not_covered',
  SubmitProformaInvoice = 'submit_proforma_invoice',
  SubmitInvoice = 'submit_invoice',
  AddInvoice = 'add_invoice',
  AddProformaInvoice = 'add_proforma_invoice',
  InitiateRepair = 'initiate_repair',
  MarkRepairComplete = 'mark_repair_complete',
  /* ----------------------------- Global actions ----------------------------- */
  ContactCustomer = 'contact_customer_generic',
  SpotlightOnConsumer = 'spotlight_on_consumer',
  SpotlightOnRepairer = 'spotlight_on_repairer',
  SpotlightOnWarrantor = 'spotlight_on_warrantor',
  CloseCase = 'close_case',
  MoveToClosed = 'move_to_closed',
  ArchiveCase = 'archive_case',
}

export enum CaseFlowActions_Fatbikes_Warrantor {
  /* ------------------------ Station specific actions ------------------------ */
  RepairCovered = 'repair_covered',
  RepairNotCovered = 'repair_not_covered',
  ApproveInvoice = 'approve_invoice',
  RejectInvoice = 'reject_invoice',
  CloseCase = 'close_case',
  /* ----------------------------- Global actions ----------------------------- */
  ContactCustomer = 'contact_customer_generic',
  InternalComment = 'internal_comment_generic',
  AssignCase = 'assign_case',
  // spotlights
  SpotlightOnConsumer = 'spotlight_on_consumer',
  SpotlightOnRepairer = 'spotlight_on_repairer',
  SpotlightOnWarrantor = 'spotlight_on_warrantor',
  // station movement
  MoveToPreliminaryAssessment = 'move_to_preliminary_assessment',
  MoveToProformaInvoiceAssessment = 'move_to_proforma_invoice_assessment',
  MoveToProformaInvoiceAccepted = 'move_to_proforma_invoice_accepted',
  MoveToRepairInvoiceAssessment = 'move_to_repair_invoice_assessment',
  MoveToInvoiceAccepted = 'move_to_invoice_accepted',
  MoveToInRepair = 'move_to_in_repair',
  MoveToRepaired = 'move_to_repaired',
  MoveToClosed = 'move_to_closed',
  MoveToArchived = 'move_to_archived',
  // cost logging
  LogAdministrativeCost = 'log_costs_administrative_time',
  LogPartsUsedCost = 'log_costs_parts_used',
  LogRepairTime = 'log_costs_repair_time',
  LogShippingCost = 'log_costs_shipping',
  LogTravelCost = 'log_costs_travel',
  LogOtherCost = 'log_costs_other',
}
